import { Typography, Box, createTheme, ThemeProvider } from "@mui/material";
import baseTheme from "../../../themes/baseTheme";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import QuizIcon from "@mui/icons-material/Quiz";
import edit from "../../../icons/edit.svg";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material";

const { palette } = baseTheme;
const theme = createTheme({});
const padding = "16px 24px";

export default function CheckListGridItem({
  status,
  headers = [],
  checklistDetailId,
  checklistName,
  templateId,
  ...props
}) {
  const navigate = useNavigate();
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  return (
    <>
      <ThemeProvider theme={theme}>
        <Box
          display="flex"
          padding={padding}
          borderBottom="solid 1px"
          borderColor={palette.grey[30]}
          alignItems="center"
        >
          <Box width={headers.find((h) => h.id === "checklistName") ?? "86%"}>
            <Typography>{checklistName}</Typography>
          </Box>
          <Box width={headers.find((h) => h.id === "icons")}>
            <Tooltip title="Edit">
              <Typography className="mx-2">
                <IconButton aria-label="edit" onClick={() => navigate("/CheckListDetails?c=" +checklistDetailId+"&t="+templateId)}>
                  <img src={edit} alt="edit icon" />
                </IconButton>
              </Typography>
            </Tooltip>
          </Box>
          <Box width={headers.find((h) => h.id === "visibilityIcon")}>
            <Tooltip title={`${props.isVisible ? "Visible" :"Hidden"}`}>
              <Typography className="mx-2">
                <IconButton aria-label="Visibility" disabled>
                  {props.isVisible ? (
                    <VisibilityOff />
                  ) : (                    
                    <Visibility color="disabled" />
                  )}
                </IconButton>
              </Typography>
            </Tooltip>
          </Box>
          <Box width={headers.find((h) => h.id === "questions")}>
            <Tooltip title="Questions">
              <Typography className="mx-2">
                <IconButton aria-label="Questions" onClick={() => navigate("/CheckListDetails?c=" +checklistDetailId+"&tab=Question&t="+templateId)}>
                  <QuizIcon />
                </IconButton>
              </Typography>
            </Tooltip>
          </Box>
        </Box>
      </ThemeProvider>
    </>
  );
}
